import { toast } from 'react-toastify';
import appApi from '../../../../../../api/app-api';
import { displayErrorText } from '../../../../../../api/errors/api-error-codes';
import { PendingDepositPaymentEntity } from '../../../../../../api/types/accounting/pending-deposit-payment-entity';
import { PendingDepositPaymentsFilterType } from '../waiting-for-deposit-filter.type';

export const getPendingDepositPaymentsOperation = async (
  filters: PendingDepositPaymentsFilterType,
  setData: (data: PendingDepositPaymentEntity[]) => void,
  setLoading: (loading: boolean) => void,
) => {
  try {
    setLoading(true);

    const res = await appApi.getPendingDepositPayments({
      shouldReceiveCrm: filters.shouldReceiveCrm,
      shouldReceivePayments: filters.shouldReceivePayments,
      startFromDate: filters.startFromDate ?? null,
      toDate: filters.toDate ?? null,
      paymentType: filters.paymentType ?? [],
      checkDueDateFrom: filters.checkDueDateFrom ?? null,
      checkDueDateTo: filters.checkDueDateTo ?? null,
    });

    if (res.data.errCode) {
      toast.warn(displayErrorText(res.data.errCode));
      setLoading(false);
      return;
    }

    setData(res.data.body ?? []);
    setLoading(false);
  } catch (e) {
    toast.error('משהו קרה, יש לנסות שוב בעוד מספר רגעים');
    setLoading(false);
  }
};
